(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsTypesController', ScriptsTypesController);

    ScriptsTypesController.$inject = ['$scope', '$state', 'ScriptsTypes', 'ParseLinks', 'AlertService'];

    function ScriptsTypesController ($scope, $state, ScriptsTypes, ParseLinks, AlertService) {
        var vm = this;
        vm.scriptsTypes = [];
        vm.predicates = {};
        vm.page = 0;
        vm.currentState = "scripts-type";
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.loadAll = function() {
            ScriptsTypes.query({
                page: vm.page,
                size: 20,
                sort: sort()
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.scriptsTypes.push(data[i]);
                }
                if(vm.page == 0 && vm.page < vm.links['last'])
                    vm.loadPage(vm.page + 1);
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        };
        vm.reset = function() {
            vm.page = 0;
            vm.scriptsTypes = [];
            var orderCall = vm.loadAll();
        };
        vm.loadPage = function(page) {
            vm.page = page;
            vm.loadAll();
        };

        vm.loadAll();

    }
})();
